import React, { memo, useEffect, useState } from "react";
import styles from "./VerificationModal.module.css";
import axios from "axios";
import { DEV_API } from "../Common/Constant";
import { updateLoginInfo } from "../slice/userInfoSlice";
import { useDispatch } from "react-redux";
import VerificationSuccess from "./VerificationSuccess";

const initErr = {};

const VerificationModal = ({ onBack, onSignup, form }) => {
  const dispatch = useDispatch();
  const [verifyForm, setverifyForm] = useState({
    verificationCode: "",
  });
  const [errors, setErrors] = useState(initErr);
  const [signUpErr, updateSignUpErr] = useState("");
  const [enableResendCode, setDisableResendCode] = useState(false);
  const [verificationSuccess, setVerifySuccess] = useState(false);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      setDisableResendCode(true);
    }, 1000 * 60 * 1);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  const onVerificationCodeChange = (e) => {
    setverifyForm({ verificationCode: e?.target?.value });
  };

  const onResendCode = () => {
    setDisableResendCode(false);
    onSignup();
  };

  const onVerifyCode = (e) => {
    e?.preventDefault && e.preventDefault();
    if (!verifyForm.verificationCode) {
      const errs = {};
      errs.verificationCode = "verification Code is required";
      setErrors(errs);
    } else {
      const req = {
        email: form.email,
        mobile: form.mobile,
        verificationCode: verifyForm.verificationCode,
      };
      axios
        .post(`${DEV_API}/users/verify-user`, req)
        .then((res) => {
          const authHeader = res.headers['authorization'];
          if (authHeader) {
            const token = authHeader.replace('Bearer ', ''); // remove Bearer prefix if present
            // Optionally, store it in localStorage
            window.localStorage.setItem("token", token);
            dispatch(updateLoginInfo(form));
            setVerifySuccess(true);
          } else {
            updateSignUpErr("Auth Not Found");
          }
        })
        .catch((err) => {
          console.error("err----", err);
          updateSignUpErr(err?.response?.data?.error);
        });
    }
  };

  const getErrorList = () => {
    const values = Object.values(errors).filter((val) => val !== "");
    const result = values.length ? values.join(". ") + "." : "";
    return result;
  };

  const verrificationCodeForm = () => {
    return (
      <>
        <div className={styles.signUpFormHeader}>
          <h2 className={`m0 ${styles.ellipsis}`}>Email Verification</h2>
          <button
            className={`${styles.backBtn} ${styles.ellipsis}`}
            onClick={onBack}
          >
            ← Change email id
          </button>
        </div>
        <div className={styles.verifyFormContainer}>
          <h4 className="m0">
            Verification code sent to {form.email}. Please enter verification
            code to continue.
          </h4>
          <form id="verifyForm" onSubmit={onVerifyCode} className={styles.form}>
            <div className={styles.row}>
              <div className={styles.formGroup}>
                <input
                  name="verificationCode"
                  value={verifyForm.verificationCode}
                  onChange={onVerificationCodeChange}
                />
                {errors.verificationCode && (
                  <p className={styles.error}>{errors.verificationCode}</p>
                )}
              </div>
            </div>
          </form>
        </div>
        <div className={styles.signUpFormFooter}>
          <button
            form="verifyForm"
            type="submit"
            className={styles.submitButton}
          >
            Verify Code
          </button>
          {enableResendCode && (
            <button
              className={`${styles.submitButton} ${styles.resendButton}`}
              onClick={onResendCode}
            >
              Resend Code
            </button>
          )}
          {Object.keys(errors).length != 0 && (
            <div className={styles.errorList}>{getErrorList()}</div>
          )}
          {signUpErr && (
            <div className={`bolder ${styles.errorList}`}>{signUpErr}</div>
          )}
        </div>
      </>
    );
  };

  if(verificationSuccess){
    return <VerificationSuccess/>
  }

  return (
    <>
      <div className={styles.overlay}>
        <div className={styles.modal}>{verrificationCodeForm()}</div>
      </div>
    </>
  );
};

VerificationModal.whyDidYouRender = true;

export default memo(VerificationModal);
